import React, { useEffect, useState } from 'react';
import styles from "./CartItem.module.scss";
import Utilities from "../../../utils/Utilities";
import { VscChromeClose, VscLockSmall } from "react-icons/vsc";
import { Tooltip } from 'react-tooltip';

function CartItem(props) {
  const [hideTooltip, setHideTooltip] = useState(false);
  const handleDeSelectButtonClick = (event) => {
    if (props.onServiceDeSelect) {
      props.onServiceDeSelect(props.item);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', () => {
      setHideTooltip(true);
    });
    
    // Detect scroll end using a debouncing technique
    let scrollTimeout;
    
    window.addEventListener('scroll', () => {
      // Clear the previous timeout to debounce the scroll event
      clearTimeout(scrollTimeout);
    
      // Set a new timeout
      scrollTimeout = setTimeout(() => {
        // This function will be called after scrolling stops
        setHideTooltip(false);
      }, 250); // Adjust this timeout value as needed
    });
  }, [])

  return (
    <>
      {props.item.selectionMode === Utilities.MANUAL && (
        <div className={styles["cart-item"]}>
          <span className={styles["cart-item-name"]}>{props.item.name[0].toUpperCase() + props.item.name.slice(1).toLowerCase()}</span>
          <VscChromeClose
            size="12"
            className={styles["cart-item-close-icon"]}
            onClick={handleDeSelectButtonClick}
          />
        </div>
      )}

      {props.item.selectionMode === Utilities.INCLUDED && (
        <>
          <div className={styles["cart-item-included"]}
            data-tooltip-id="info-icon-tooltip"
            data-tooltip-hidden={hideTooltip}
            data-tooltip-content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
            data-tooltip-place="top-end"
          >
            <span className={styles["cart-item-name"]}>{props.item.name[0].toUpperCase() + props.item.name.slice(1).toLowerCase()}</span>
            <VscLockSmall size="15" className={styles["cart-item-lock-icon"]} />
          </div>
          <Tooltip
            id="info-icon-tooltip"
            className={styles["infoTooltip"]}
            place="top-end"
            type="light"
            style={{
              width: "264px",
              backgroundColor: "white",
              boxShadow: "-0px -0px 10px #2222221A",
              color: "#222",
              opacity: "1",
              fontFamily: "Poppins",
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "19px",
              letterSpacing: "0em",
              textAlign: "left",
            }}
          />
        </>
      )}
    </>

  );
}

export default CartItem;
